import { toJS, autorun, useStrict } from 'mobx'
import authStore from './auth/auth-store'
import assessStore from './assess/assess-store'
import trendStore from './home/trend-store'
import resultStore from './result/result-store'

useStrict(true)
if (process.env.NODE_ENV === 'development') {
  autorun(() => console.log('authStore', toJS(authStore)))
  autorun(() => console.log('assessStore', toJS(assessStore)))
  autorun(() => console.log('trendStore', toJS(trendStore)))
  autorun(() => console.log('resultStore', toJS(resultStore)))
}

window.assessStore = assessStore
window.authStore = authStore
window.trendStore = trendStore
window.resultStore = resultStore

export {
  authStore,
  assessStore,
  trendStore,
  resultStore
}



// WEBPACK FOOTER //
// ./src/stores.js